<template>
  <div class="danh-sach-nguoi-dung-theo-vai-tro">
    <form @submit.prevent>
      <div class="d-flex align-items-center mb-3">
        <label class="label-table m-0 flex-1-0"
          >Danh sách người dùng trong nhóm</label
        >
        <base-button
          v-if="
            !readonly &&
            hasPermissionUser(PERMISSION_NAME.NHOM_NGUOI_DUNG.THEM_NGUOI_DUNG)
          "
          class="btn search-information-btn d-block ml-2"
          button="Thêm người dùng"
          color="btn-success"
          @click="moFormThemDanhSachNguoiDung()"
        >
          Thêm người dùng
        </base-button>
        <base-button
          v-if="
            !readonly &&
            hasPermissionUser(PERMISSION_NAME.NHOM_NGUOI_DUNG.XOA_NGUOI_DUNG)
          "
          :disabled="danhSachIdNguoiDungDaChon.length === 0"
          class="btn search-information-btn d-block"
          button="Xóa người dùng đã chọn"
          @click="moFormXacNhanXoa()"
        >
          Xóa vai trò đã chọn
        </base-button>
      </div>
    </form>
    <div class="box-form-result">
      <DataTable
        :value="danhSachNguoiDungNoiBo"
        :loading="isLoadingTable"
        :selection.sync="selectedCanBo"
        :auto-layout="true"
        :rowClass="rowClass"
      >
        <Column
          field="id"
          headerStyle="width: 40px"
          header=""
          bodyStyle="text-align: center"
          bodyClass="select-column"
          selectionMode="multiple"
          v-if="!readonly"
          :filter-header-class="readonly ? 'd-none' : ''"
          :body-class="readonly ? 'd-none' : ''"
          :header-class="readonly ? 'd-none p-2' : 'p-2'"
        >
        </Column>
        <Column
          field="stt"
          dataKey="stt"
          headerStyle="width: 40px"
          headerClass="p-2"
          header="STT"
          bodyStyle="text-align: center"
        >
          <template #filter> </template>
          <template #body="slotProps">
            <span>{{
              (requestInformation.pageIndex - 1) * requestInformation.pageSize +
              slotProps.index +
              1
            }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="userName"
          header="Tên đăng nhập"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.UserName"
              @change="layDanhSachNguoiDung"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.userName }}</span>
          </template>
        </Column>

        <Column
          filterMatchMode="custom"
          field="name"
          header="Họ tên"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.Name"
              @change="layDanhSachNguoiDung"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.name }}</span>
          </template>
        </Column>

        <Column
          filterMatchMode="custom"
          field="donVi"
          header="Đơn vị"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.donVi"
              @change="layDanhSachNguoiDung"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.donVi }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="chucVu"
          header="Chức vụ"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.chucVu"
              @change="layDanhSachNguoiDung"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.chucVu }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="vaiTro"
          header="Vai trò"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.vaiTro"
              @change="layDanhSachNguoiDung"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.roleName }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="thaoTac"
          header="Thao tác"
          headerStyle="width: 100px"
          v-if="
            !readonly &&
            hasPermissionUser(PERMISSION_NAME.NHOM_NGUOI_DUNG.XOA_NGUOI_DUNG)
          "
        >
          <template #body="slotProps">
            <div class="text-center">
              <font-awesome-icon
                icon="trash-alt"
                v-if="
                  !slotProps.data.isFromRole &&
                  slotProps.data.canDelete &&
                  hasPermissionUser(
                    PERMISSION_NAME.NHOM_NGUOI_DUNG.XOA_NGUOI_DUNG
                  )
                "
                v-b-popover.hover.top="'Xóa nhóm người dùng'"
                class="cursor-pointer color-red ml-2"
                @click="xoaNguoiDung(slotProps.data.id)"
              />
            </div>
          </template>
        </Column>
        <template #empty
          ><div class="text-center">Không có dữ liệu</div></template
        >
        <template #loading
          ><div class="text-center">Đang tải dữ liệu ...</div>
        </template>
      </DataTable>
    </div>
    <BasePagination
      class="mt-3"
      :total-pages="danhSachNguoiDung.totalPage"
      :total-rows="danhSachNguoiDung.totalCount"
      :current-page="requestInformation.pageIndex"
      @changePages="onChangePages($event)"
      @changeNum="onChangeNum($event)"
    />
    <XoaNguoiDungGroupModal
      :title="'Bạn có muốn xóa người dùng khỏi nhóm người dùng?'"
      :isLoading="isLoadingAction"
      @xoaNguoiDung="xoaDanhSachNguoiDung"
    />
    <b-modal
      id="them-nguoi-dung-modal"
      size="xl"
      title="Thêm người dùng cho nhóm"
      :hide-footer="true"
    >
      <DanhSachNguoiDungHeThong
        ref="danhSachNguoiDungHeThong"
        :key="`he-thong-${groupId}`"
        :groupId="groupId"
        @close="dongFormThemDanhSachNguoiDung"
        @layDanhSachNguoiDungTheoVaiTro="layDanhSachNguoiDung"
        @themNguoiDungVaoGroup="capNhatNguoiDungGroup"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";
import {
  LOI_CHUA_CHON_NGUOI_DUNG,
  XOA_NGUOI_DUNG_THANH_CONG,
  THEM_NGUOI_DUNG_VAO_NHOM_THANH_CONG,
} from "@/constants/message";
import QuanLyNguoiDung from "@/mixins/QuanLyNguoiDung";
import XoaNguoiDungGroupModal from "@/components/pages/quan-tri-he-thong/nguoi-dung/XoaNguoiDungGroupModal";
import DanhSachNguoiDungHeThong from "@/components/pages/quan-tri-he-thong/nguoi-dung/DanhSachNguoiDungKhongThuocGroup";
import {
  NO_RESULTS_TEXT,
  TREE_SELECT_PLACEHOLDER,
  PERMISSION_NAME,
} from "@/constants/constants";
import { hasPermissionUser } from "@/utils/permissionUtils";
export default {
  name: "DanhSachNguoiDungTheoGroup",
  mixins: [QuanLyNguoiDung],
  components: {
    XoaNguoiDungGroupModal,
    DanhSachNguoiDungHeThong,
  },
  data() {
    return {
      PERMISSION_NAME,
      NO_RESULTS_TEXT: NO_RESULTS_TEXT,
      TREE_SELECT_PLACEHOLDER: TREE_SELECT_PLACEHOLDER,
      danhSachIdNguoiDungMuonXoa: [],
      groupId: null,
      options: [],
      danhSachIdNguoiDung: [],
      requestForm: {},
      selectedCanBo: [],
    };
  },
  computed: {
    ...mapGetters({
      danhSachNguoiDung: "user/danhSachNguoiDungTheoGroup",
    }),
  },
  watch: {
    danhSachNguoiDung: {
      handler() {
        this.totalPages = this.danhSachNguoiDung.totalPage;
        this.totalRows = _isNil(this.danhSachNguoiDung.totalCount)
          ? 0
          : this.danhSachNguoiDung.totalCount;

        this.danhSachNguoiDungNoiBo = this.layDanhSachNguoiDungNoiBo(
          this.danhSachNguoiDung
        );
        this.danhSachIdNguoiDung = this.layIdDanhSachNguoiDung(
          this.danhSachNguoiDung
        );
      },
      deep: true,
    },
    chiTietGroup: {
      handler() {
        if (!_isEmpty(this.chiTietGroup)) {
          this.groupId = this.chiTietGroup.id;
          this.layDanhSachNguoiDung();
        }
      },
    },
    selectedCanBo: {
      handler() {
        this.danhSachIdNguoiDungDaChon = this.selectedCanBo
          .filter((i) => !i.isFromRole && i.canDelete)
          .map((x) => x.id);
      },
      deep: true,
    },
  },
  created() {
    this.layDanhSachNguoiDung();
  },
  methods: {
    hasPermissionUser,
    rowClass(rowData) {
      if (rowData.isFromRole) {
        return "disabled-background-row";
      }
      if (!rowData.canDelete) {
        return "disable-select";
      }
      return "";
    },
    xoaNguoiDung(nguoiDungId) {
      this.danhSachIdNguoiDungMuonXoa = [nguoiDungId];
      this.$bvModal.show("xoa-nguoi-dung-group");
    },
    moFormThemDanhSachNguoiDung() {
      this.$bvModal.show("them-nguoi-dung-modal");
    },
    dongFormThemDanhSachNguoiDung() {
      this.$bvModal.hide("them-nguoi-dung-modal");
    },
    moFormXacNhanXoa() {
      if (_isEmpty(this.selectedCanBo) || this.selectedCanBo.length === 0) {
        this.$toasted.clear();
        this.$toasted.global.showErrorMessage({
          message: LOI_CHUA_CHON_NGUOI_DUNG,
        });
        return;
      }
      this.danhSachIdNguoiDungMuonXoa = this.danhSachIdNguoiDungDaChon;
      this.$bvModal.show("xoa-nguoi-dung-group");
    },
    xoaDanhSachNguoiDung() {
      const payload = {
        Id: this.chiTietGroup.id,
        Code: this.chiTietGroup.code,
        Name: this.chiTietGroup.name,
        AppId: this.chiTietGroup.appId,
        Description: this.chiTietGroup.description,
        lstUserCanBoDepartmentInGroupId: this.danhSachIdNguoiDungMuonXoa,
        LstRole: null,
        LstPermission: null,
      };
      this.isLoadingAction = true;
      this.$store
        .dispatch("group/removeMapping", payload)
        .then((response) => {
          this.isLoadingAction = false;
          this.$toasted.clear();
          this.$toasted.global.showSuccessMessage({
            message: XOA_NGUOI_DUNG_THANH_CONG,
          });
          this.$bvModal.hide("xoa-nguoi-dung-group");
          this.danhSachIdNguoiDungDaChon =
            this.danhSachIdNguoiDungDaChon.filter(
              (x) => !this.danhSachIdNguoiDungMuonXoa.includes(x)
            );
          this.layDanhSachNguoiDung();
        })
        .catch(() => {
          this.$toasted.clear();
          this.$toasted.global.showErrorMessage({
            message: "Thao tác thất bại",
          });
          this.isLoadingAction = false;
        });
    },
    layDanhSachNguoiDung() {
      if (this.groupId) {
        const payload = {
          ...this.requestInformation,
          ...this.requestForm,
          groupId: this.groupId,
        };
        this.isLoadingTable = true;
        this.$store
          .dispatch("user/layDanhSachNguoiDungTheoGroup", payload)
          .then(() => {
            this.isLoadingTable = false;
          });
      }
    },
    layDanhSachNguoiDungNoiBo(danhSachNguoiDung) {
      if (_isEmpty(danhSachNguoiDung.items)) {
        return [];
      }
      return danhSachNguoiDung.items.map((item, index) => {
        return {
          checkbox: null,
          stt:
            (this.requestInformation.pageIndex - 1) *
              this.requestInformation.pageSize +
            index +
            1,
          id: _isNil(item.id) ? "" : item.id,
          userId: _isNil(item.userId) ? "" : item.userId,
          userName: _isNil(item.userName) ? "" : item.userName,
          donVi: _isNil(item.donVi) ? "" : item.donVi,
          name: _isNil(item.name) ? "" : item.name,
          chucVu: _isNil(item.chucVu) ? "" : item.chucVu,
          roleName: _isNil(item.roleName) ? "" : item.roleName,
          isFromRole: item.isFromRole,
          canDelete: item.canDelete,
          thaoTac: "thaoTac",
        };
      });
    },
    layIdDanhSachNguoiDung(danhSachNguoiDung) {
      if (_isEmpty(danhSachNguoiDung.items)) {
        return [];
      }
      return danhSachNguoiDung.items.map((item) => {
        return item.userId;
      });
    },
    capNhatNguoiDungGroup(closeModal) {
      let danhSachIdNguoiDungThemMoi =
        this.$refs["danhSachNguoiDungHeThong"].danhSachIdNguoiDungDaChon;
      const payload = {
        Id: this.chiTietGroup.id,
        Code: this.chiTietGroup.code,
        Name: this.chiTietGroup.name,
        AppId: this.chiTietGroup.appId,
        Description: this.chiTietGroup.description,
        lstUserCanBoDepartmentInGroupId: danhSachIdNguoiDungThemMoi,
        LstRole: null,
        LstPermission: null,
      };
      this.$store
        .dispatch("group/addMapping", payload)
        .then((response) => {
          this.$toasted.clear();
          this.$toasted.global.showSuccessMessage({
            message: THEM_NGUOI_DUNG_VAO_NHOM_THANH_CONG,
          });
          if (closeModal) {
            this.$bvModal.hide("them-nguoi-dung-modal");
          }
          this.layDanhSachNguoiDung();
        })
        .catch(() => {
          if (closeModal) {
            this.$bvModal.hide("them-nguoi-dung-modal");
          }
        });
    },
  },
};
</script>

<style lang="scss">
.danh-sach-nguoi-dung-theo-vai-tro {
  .label-table {
    font-size: 16px !important;
    margin-top: 3px;
    margin-right: 5px;
    margin-left: -5px;
    font-weight: bold;
  }
  .disable-select {
    .select-column {
      .p-checkbox.p-component {
        display: none;
      }
    }
  }
}
</style>